module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAALElEQVQoU2NkwAK8Oi7/Bwlvq9BlRJfGEAApGGoaYO7F5nlsYowkaxiJwQoAafwtVSz4yU0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/hospital-img/add.png
// module id = mzXT
// module chunks = 1